module.exports = __webpack_public_path__ + "img/extraordinary_contribution.b435c724.svg";